module.exports = __webpack_public_path__ + "assets/img/sy_5g_3_ylb.61520a10.png";